import { Component, OnInit } from '@angular/core';
import { DashboardChart1Component } from '../../components/dashboard-chart1/dashboard-chart1.component';
import { DashboardChart2Component } from '../../components/dashboard-chart2/dashboard-chart2.component';
import { DashboardChart3Component } from '../../components/dashboard-chart3/dashboard-chart3.component';
import { DashboardChart4Component } from '../../components/dashboard-chart4/dashboard-chart4.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dasahboard-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
  standalone: true,
  imports: [
    DashboardChart1Component,
    DashboardChart2Component,
    DashboardChart3Component,
    DashboardChart4Component,
    FlexLayoutModule,
    CommonModule
  ]
})
export class DashboardChartsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
